import { BaseDto } from 'src/dtos/common/baseDto';

/** 가족관계 행과 화면 편집 상태이다. */
export interface HrmFamilyDto extends BaseDto {
    empNo: string; // 사원번호
    familySeq: number | null; // 사원별 순번, 신규는 null
    familyNm: string; // 성명
    relationCd: string; // 관계 코드
    resnoBirth: string; // 주민번호 앞자리
    resnoLastkey: string; // 주민번호 뒷자리 첫 숫자와 마스킹 문자
    supportYn: string; // 부양 여부
    deductTaxYn: string; // 세액공제 여부
    schoolSupportYn: string; // 학자금 여부
    remark: string; // 비고
    inserted: boolean; // 저장되지 않은 행이면 true
    isModified: boolean; // 조회 후 수정했으면 true
}

/** 가족관계 신규 행의 기본값이다. */
export const defaultHrmFamilyDto: HrmFamilyDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', familySeq: null, familyNm: '', relationCd: '02',
    resnoBirth: '', resnoLastkey: '', supportYn: 'Y', deductTaxYn: 'Y',
    schoolSupportYn: 'N', remark: '', inserted: false, isModified: false,
};
